import React from 'react';
import { Link } from 'react-router-dom';

// Import CSS styles
import './styles/RecipeTemplate.css';

interface RecipeTemplateProps {
  title: string;
  publishedAt: string;
  author?: { name: string };
  image?: { url: string; altText?: string };
  excerpt?: string;
  contentHtml: string;
  tags?: string[];
  backLink?: string;
  backLinkText?: string;
}

const RecipeTemplate: React.FC<RecipeTemplateProps> = ({
  title,
  publishedAt,
  author,
  image,
  excerpt,
  contentHtml,
  tags,
  backLink = '/recipes',
  backLinkText = 'Back to Recipes'
}) => {
  const date = new Date(publishedAt).toLocaleDateString(undefined, { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });
  
  return (
    <div className="recipe-container">
      <Link to={backLink} className="recipe-back-link">
        {backLinkText}
      </Link>
      
      <div className="recipe-wrapper">
        {image && (
          <div className="recipe-hero">
            <img 
              src={image.url} 
              alt={image.altText || title} 
            />
          </div>
        )}
        
        <div className="recipe-header">
          <div className="recipe-section">
            <h1 className="recipe-title">{title}</h1>
            
            <div className="recipe-meta">
              <span>Published: {date}</span>
              {author && <span>By: {author.name}</span>}
            </div>
            
            {excerpt && (
              <div className="recipe-intro">
                {excerpt}
              </div>
            )}
          </div>
        </div>
        
        <div className="recipe-content">
          <div className="recipe-section">
            <div dangerouslySetInnerHTML={{ __html: contentHtml }} />
          </div>
        </div>
        
        {tags && tags.length > 0 && (
          <div className="recipe-section">
            <div className="tags-container">
              <h2 className="section-title">Tags</h2>
              <div>
                {tags.map((tag, index) => (
                  <span className="recipe-tag" key={index}>{tag}</span>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecipeTemplate;
